import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useCategories from "../../../hooks/useCategories";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const EditAudio = () => {
   const {id } = useParams();
  const navigate = useNavigate();
  const { categories } = useCategories();

  const [form, setForm] = useState({
    name: "",
    description: "",
    category: "",
    subcategory: "",
    course_type: "free",
    price: "",
  });

  const [displayNames, setDisplayNames] = useState({
    category_name: "",
    subcategory_name: "",
  });

  const [file, setFile] = useState(null);
  const [originalFile, setOriginalFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [availableSubcategories, setAvailableSubcategories] = useState([]);
  const [additionalResources,setAdditionalResources] = useState([])
  const fetchDetails = async () => {
    try {
      setLoading(true);
      console.log()
   

      const res = await fetch(`${BASE_URL}/courses/audio/${id}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      const data = await res.json();

      setForm({
        name: data?.name || "",
        description: data?.description || "",
        category: data?.category || "",
        subcategory: data?.subcategory || "",
        course_type: data?.course_type || "free",
        price: data?.price || "",
      });

      setDisplayNames({
        category_name: data?.category_name || "",
        subcategory_name: data?.subcategory_name || "",
      });

      if (data?.file) {
        const fileName = data.file.split("/").pop() || `$Audio_${id}`;
        setOriginalFile({
          url: data.file,
          name: fileName,
          isOriginal: true
        });
      }

      const selectedCat = categories.find(c => c.id === data?.category);
      setAvailableSubcategories(selectedCat?.subcategories || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (categories.length > 0) {
      fetchDetails();
    }
  }, [id, categories]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm(prev => {
      const updated = { ...prev, [name]: value };

      if (name === "category") {
        const selectedCat = categories.find(c => c.id === parseInt(value));
        setAvailableSubcategories(selectedCat?.subcategories || []);
        updated.subcategory = "";

        if (selectedCat) {
          setDisplayNames(prevNames => ({
            ...prevNames,
            category_name: selectedCat.name,
            subcategory_name: ""
          }));
        }
      }

      if (name === "subcategory") {
        const selectedSubcat = availableSubcategories.find(s => s.id === parseInt(value));
        if (selectedSubcat) {
          setDisplayNames(prevNames => ({
            ...prevNames,
            subcategory_name: selectedSubcat.name
          }));
        }
      }

      return updated;
    });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleUpdate = async () => {
    try {
      setSaving(true);
      const formData = new FormData();

      Object.keys(form).forEach(key => {
        if (key === 'category' || key === 'subcategory') {
          formData.append(key, parseInt(form[key]) || "");
        } else {
          formData.append(key, form[key]);
        }
      });

      if (file) {
        formData.append("file", file);
      } else if (originalFile === null) {
        formData.append("file", "");
      }
      additionalResources.forEach((file)=>{
           formData.append('resources',file)
      })
      await fetch(`${BASE_URL}/courses/audio/${id}/update/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      });

      alert(`Aduio updated successfully`);
     
            navigate(`/teacher/audios`);
    } catch (err) {
      console.error(err);
      alert("Error updating. Please try again.");
    } finally {
      setSaving(false);
    }
  };

   {loading && (
  <div className="flex flex-col items-center justify-center py-12">
    <svg className="animate-spin h-10 w-10 text-indigo-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <p className="text-slate-600 text-lg font-medium">Loading ...</p>
  </div>
)}
  return (
    <div className="max-w-5xl mx-auto my-8 p-6 bg-white rounded-2xl border border-gray-200 shadow-sm">
  {/* Header */}
 <div className="flex items-center gap-3 mb-8">
  <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
    <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
    </svg>
  </div>
  <h1 className="text-xl font-semibold text-gray-900">Edit Audio</h1>
</div>
  {/* NAME */}
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Name</label>
    </div>
    <input
      type="text"
      name="name"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      value={form.name}
      onChange={handleChange}
    />
  </div>

  {/* DESCRIPTION */}
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Description</label>
    </div>
    <textarea
      name="description"
      rows={4}
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-y"
      value={form.description}
      onChange={handleChange}
    />
  </div>

  {/* FILE UPLOAD SECTION */}
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">PodCast File</label>
    </div>

    {originalFile && !file && (
      <div className="bg-gray-50 p-4 rounded-xl border border-gray-200 mb-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
            </svg>
          </div>
          <span className="text-sm text-gray-500">Current File</span>
        </div>
        <div className="flex items-center gap-3">
          <a
            href={originalFile.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-[#0f6abf] hover:underline"
          >
            {originalFile.name}
          </a>
          <span className="text-xs px-2 py-1 bg-gray-200 text-gray-700 rounded-lg">
            Original
          </span>
        </div>
        <div className="mt-4 rounded-xl overflow-hidden border border-gray-200">
          <audio controls className="w-full mx-auto">
            <source src={originalFile.url} type="video/mp4" />
          </audio>
        </div>
      </div>
    )}

    {file && (
      <div className="bg-gray-50 p-4 rounded-xl border border-gray-200 mb-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </div>
          <span className="text-sm text-gray-500">New File</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-gray-900">{file.name}</span>
          <span className="text-xs px-2 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg">
            New Upload
          </span>
        </div>
        {file.type.startsWith("video/") && (
          <div className="mt-4 bg-black rounded-xl overflow-hidden border border-gray-200">
            <video controls className="w-full max-w-[500px] mx-auto">
              <source src={URL.createObjectURL(file)} type={file.type} />
            </video>
          </div>
        )}
      </div>
    )}

    {!originalFile && !file && (
      <div className="bg-red-50 p-4 rounded-xl border border-red-200 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
            <svg className="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <p className="text-sm font-medium text-red-600">No file currently uploaded</p>
        </div>
      </div>
    )}

    <div className="mt-5 pt-4 border-t border-dashed border-gray-200">
      <input
        type="file"
        accept="video/*"
        onChange={handleFileChange}
        className="hidden"
        id="fileUpload"
      />
      <label
        htmlFor="fileUpload"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-100 text-gray-700 rounded-xl border border-dashed border-gray-300 font-medium hover:bg-gray-200 hover:border-gray-400 transition-colors cursor-pointer"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
        </svg>
        {originalFile ? "Upload New File (Replace)" : "Upload File"}
      </label>
      <p className="text-xs text-gray-500 mt-2">
        {originalFile
          ? file
            ? "New file will replace the original"
            : "Upload a new file to replace the current one"
          : "Upload a video file"}
      </p>
    </div>
  </div>

  {/* CATEGORY */}
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Category</label>
    </div>
    <select
      name="category"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 16px center'
      }}
      value={form.category}
      onChange={handleChange}
    >
      <option value="">Select category</option>
      {categories.map((cat) => (
        <option key={cat.id} value={cat.id}>
          {cat.name}
        </option>
      ))}
    </select>
    {displayNames.category_name && (
      <p className="mt-2 text-xs text-gray-600">
        Selected: <span className="font-medium text-gray-900">{displayNames.category_name}</span>
      </p>
    )}
  </div>

  {/* SUBCATEGORY */}
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Subcategory</label>
    </div>
    <select
      name="subcategory"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 16px center'
      }}
      value={form.subcategory}
      onChange={handleChange}
      disabled={!form.category || availableSubcategories.length === 0}
    >
      <option value="">Select subcategory</option>
      {availableSubcategories.map((sub) => (
        <option key={sub.id} value={sub.id}>
          {sub.name}
        </option>
      ))}
    </select>
    {displayNames.subcategory_name && (
      <p className="mt-2 text-xs text-gray-600">
        Selected: <span className="font-medium text-gray-900">{displayNames.subcategory_name}</span>
      </p>
    )}
  </div>

  {/* COURSE TYPE */}
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Course Type</label>
    </div>
    <select
      name="course_type"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 16px center'
      }}
      value={form.course_type}
      onChange={handleChange}
    >
      <option value="free">Free</option>
      <option value="paid">Paid</option>
    </select>
  </div>

  {/* PRICE */}
  {form.course_type === "paid" && (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">Price ($)</label>
      </div>
      <input
        type="number"
        name="price"
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        value={form.price}
        onChange={handleChange}
        min="0"
        step="0.01"
      />
    </div>
  )}

  {/* ADDITIONAL RESOURCES */}
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Additional Resources</label>
    </div>
    <div className="relative">
      <input
        type="file"
        multiple
        onChange={(e) => setAdditionalResources([...e.target.files])}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-[#e8f0f7] file:text-[#0f6abf] file:text-sm file:font-medium hover:file:bg-[#d0e0f0] transition-all"
      />
    </div>
  </div>

  {/* SAVE BUTTON */}
  <button
    className="w-full py-3.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    onClick={handleUpdate}
    disabled={saving}
  >
    {saving ? (
      <div className="flex items-center justify-center gap-2">
        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        Saving...
      </div>
    ) : (
      "Save Changes"
    )}
  </button>
</div>
  );
};

export default EditAudio;